/**
 * Chip tones for icon rows on the dark steel surfaces. Low-saturation fills so
 * rows read as instrumentation tags, never as a rainbow.
 * Cycled by index across card lists.
 */
export interface IconTone {
  bg: string
  fg: string
}

export const iconTones: IconTone[] = [
  { bg: 'bg-ember-500/12', fg: 'text-ember-400' },
  { bg: 'bg-circuit-400/12', fg: 'text-circuit-300' },
  { bg: 'bg-white/[0.06]', fg: 'text-ink-200' },
  { bg: 'bg-circuit-500/12', fg: 'text-circuit-400' },
  { bg: 'bg-ember-400/12', fg: 'text-ember-300' },
  { bg: 'bg-white/[0.05]', fg: 'text-ink-400' },
]

export function toneAt(index: number): IconTone {
  return iconTones[index % iconTones.length]
}
